import { ACTIONS } from "../../Models/ENUM";
import CONQUER from "../CONQUER";
import FriendInstance from "./FriendInstance";
import LOG, { log } from "../../UTIL/LOG";
import Cue from "../../UTIL/Instances/Cue";

class Friends
{
    private conquer : CONQUER;
    private isLoaded : boolean = false;

    public constructor( instance:CONQUER ) 
    {
        this.conquer = instance;
    }

    public pool     : any = [];
    public active   : any = [];
    public cue      : any;
    private counter : number = 0;

    /*=============== 


    GET
    

    ================*/

    public async get( force?:boolean ) : Promise<any>
    {
        
       // return Promise.resolve( this.pool );
        if( this.isLoaded && !force ) return Promise.resolve( this.pool );

        this.pool       = [];

        if( this.conquer.User.type != "USERNAME" ) return Promise.resolve( this.refresh() );

        let array       = await this.conquer.do( ACTIONS.FRIENDS_GET );
        
        this.isLoaded   = true;
 
        for( var n in array ) this.pool.push( new FriendInstance( this.conquer, array[n] ) );
 
        return Promise.resolve( this.refresh() );
    };

    public refresh()
    {
        this.active     = [];
        this.cue        = new Cue( true );

        for( var n in this.pool )
        {
            let item : FriendInstance = this.pool[n];

            if( item.status != "active" ) continue;

            this.active.push( item );
            this.cue.push( item );
        }

        return this.pool;
    }

    /*=============== 


    GET
    

    ================*/

    public async getRandom() : Promise<any>
    {
        if( !this.isLoaded ) await this.get();
 
        return Promise.resolve( this.cue.get() );
    };

    public async getOrBot() : Promise<any>
    {
        let friend;
 
        this.counter ++;

        if( ++this.counter > 3 ) this.counter = 0; 
        if( this.counter > 0 ) friend = await this.getRandom();
 
        if( !friend )
        {
            let bots = await this.conquer.Bots.get(1);
            friend = bots[0];
        }

        return Promise.resolve( friend );
    }

    /*=============== 


    SET
    

    ================*/

    public async set( friendID:any ) : Promise<any>
    {
        var friendship = await this.conquer.do( ACTIONS.FRIENDS_SET, { friendID:friendID, avatarID: this.conquer.User.avatarID } );

        return Promise.resolve( friendship );
    };

    public async setUsernames( usernames:any ) : Promise<any>
    {
        let result = await this.conquer.do( ACTIONS.FRIENDS_SET, { usernames:usernames, avatarID: this.conquer.User.avatarID } );
        return this.get( true ) ;
    };

    /*=============== 


    CHANGE
    

    ================*/

    public async change( friendID:any ) : Promise<any>
    {
        var friendship = await this.conquer.do( ACTIONS.FRIENDS_CHANGE, { friendID, avatarID: this.conquer.User.avatarID } );

        return Promise.resolve( friendship );
    };

    /*=============== 


    REMOVE
    

    ================*/

    public async remove( friendID:any ) : Promise<any>
    {
        var friendship = await this.conquer.do( ACTIONS.FRIENDS_REMOVE, { friendID, avatarID: this.conquer.User.avatarID } );

        return Promise.resolve( friendship );
    };

}

export default Friends;